module.exports = __webpack_public_path__ + "img/sfeerfoto2.ac4c48b8.jpg";